import axiosIns from '@/api/axios'

export const GET_LIST = () => {
  return axiosIns.get("/access-location-all");
};

export const DETAIL = (id) => {
  return axiosIns.get(`/access-location?id=${id}`);
};